export const printByCategory = async (category_id) => {
  const response = await fetch(`/api/stencils/print/category/${category_id}`, {
    method: "GET",
    credentials: "include",
  });
  return response;
};

export const printByStencil = async (stencil_id) => {
  const response = await fetch(`/api/stencils/print/stencil_id/${stencil_id}`, {
    method: "GET",
    credentials: "include",
  });
  return response;
};

export const printUncut = async (category) => {
  const response = await fetch(`/api/stencils/print/uncut/${category}`, {
    method: "GET",
    credentials: "include",
  });
  return response;
};
